/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef, memo } from 'react';

import cls from 'classnames';

import { LinkBase, LinkBaseProps } from './LinkBase';

import styles from './Link.scss';

const LinkComponent = forwardRef<HTMLAnchorElement, LinkBaseProps>((props, ref) => {
  return (
    <LinkBase {...props} ref={ref} className={cls(styles.root, props.className)}>
      {props.children}
    </LinkBase>
  );
});

export const Link = memo(LinkComponent);
